import { SpotterEnvironment } from "@spotter/environments/environment.template";

export const environment: SpotterEnvironment = {
    siteName: 'SeagrassTools',
    tokenSource: 'seagrass.tools',
    //production: false,
    envName: 'staging',
    apiURL: "https://api.spotterstaging.com/v1",
    apiBaseUrl: "https://api.spotterstaging.com",
   // version:"5.0.3",
    enableAnalytics: false,
    matamoSiteID: '',
    matamoSiteURL: ''
};
